const translations = {
  UserAccountDeleteConfirm: 'Wybrane konto użytkownika zostanie usunięte. Kontynuować?',
};

export default translations;
